import React from "react";
import Introduction from "./Introduction/Introduction";
import Projects from "./Projects/Projects";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";

const Engagements = () => (
  <PageLayout>
    <PageHero title="Volunteering Projects" eyebrow="Our Projects" subtitle="Projects & events that spread kindness across communities" light />
    <Introduction />
    <Projects />
  </PageLayout>
);

export default Engagements;
